import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { Encoders, sendJson, errorString } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { list_type, bool_type, string_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { ofArray, empty, append, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { BoolResult_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { TextEditModel, TextListModel, TextEditModel_Init_Z721C83C5, Msg, Model, TextListModel_get_Init } from "./Types.fs.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { errorCmd, Loaded, request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { update } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { Markdown_ToHtml_1BFEAEDB } from "../../../fable_modules/Fable.Formatting.Markdown.1.0.1/Markdown.fs.js";

export function Http_getText(key) {
    let arg;
    const response = fetch((arg = encodeURIComponent(key), toText(printf("/api/admin/text/%s"))(arg)), {
        credentials: "include",
    });
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            return response_1_1.text();
        }
    });
}

export function Http_postText(key, content) {
    let arg;
    return sendJson((arg = encodeURIComponent(key), toText(printf("/api/admin/text/%s"))(arg)), toString(0, Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)(content)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_getMaintenanceState() {
    const response = fetch("api/admin/maintenancestatus", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(BoolResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postMaintenanceState(state) {
    return sendJson("api/admin/maintenancestatus", toString(0, Auto_generateBoxedEncoder_437914C6(bool_type, undefined, undefined, undefined)(state)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_getTextList() {
    const response = fetch("/api/admin/text/", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(string_type), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(page, user, lastModel) {
    if (page.tag === 0) {
        return [new Model(0, [TextListModel_get_Init()]), singleton((dispatch_2) => {
            dispatch_2(new Msg(0, []));
        })];
    }
    else {
        const key = page.fields[0];
        return [new Model(1, [TextEditModel_Init_Z721C83C5(key)]), Cmd_batch(ofArray([singleton((dispatch) => {
            dispatch(new Msg(2, [key]));
        }), singleton((dispatch_1) => {
            dispatch_1(new Msg(4, []));
        })]))];
    }
}

export function State_update(msg, model) {
    let matchResult, model_1, result, key, model_3, content, model_5, exn, model_7, state, exn_2, model_9, value, model_11, value_1, exn_4, model_13, model_15, e, model_17;
    switch (msg.tag) {
        case 1: {
            if (model.tag === 0) {
                matchResult = 1;
                model_1 = model.fields[0];
                result = msg.fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 2: {
            if (model.tag === 1) {
                matchResult = 2;
                key = msg.fields[0];
                model_3 = model.fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 3: {
            if (msg.fields[0].tag === 1) {
                matchResult = 4;
                exn = msg.fields[0].fields[0];
            }
            else if (model.tag === 1) {
                matchResult = 3;
                content = msg.fields[0].fields[0];
                model_5 = model.fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 4: {
            matchResult = 5;
            break;
        }
        case 5: {
            if (msg.fields[0].tag === 1) {
                matchResult = 7;
                exn_2 = msg.fields[0].fields[0];
            }
            else if (model.tag === 1) {
                matchResult = 6;
                model_7 = model.fields[0];
                state = msg.fields[0].fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 6: {
            if (model.tag === 1) {
                matchResult = 8;
                model_9 = model.fields[0];
                value = msg.fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 7: {
            if (model.tag === 1) {
                matchResult = 9;
                model_11 = model.fields[0];
                value_1 = msg.fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 8: {
            if (msg.fields[0].tag === 1) {
                matchResult = 11;
                exn_4 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 10;
            }
            break;
        }
        case 9: {
            if (model.tag === 1) {
                matchResult = 12;
                model_13 = model.fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 10: {
            if (msg.fields[0].tag === 1) {
                if (model.tag === 1) {
                    matchResult = 14;
                    e = msg.fields[0].fields[0];
                    model_17 = model.fields[0];
                }
                else {
                    matchResult = 16;
                }
            }
            else if (model.tag === 1) {
                matchResult = 13;
                model_15 = model.fields[0];
            }
            else {
                matchResult = 16;
            }
            break;
        }
        case 11: {
            matchResult = 15;
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return [model, request(Http_getTextList, undefined, (Item) => (new Msg(1, [Item])))];
        case 1:
            return [new Model(0, [new TextListModel(Loaded(result))]), Cmd_none()];
        case 2:
            return [new Model(1, [new TextEditModel(key, model_3.Content, model_3.Sending, model_3.IsDirty, model_3.TextAsHtml, model_3.MaintenanceActive)]), request(Http_getText, key, (Item_2) => (new Msg(3, [Item_2])))];
        case 3:
            return [new Model(1, [new TextEditModel(model_5.Key, update(model_5.Content, content), model_5.Sending, false, Markdown_ToHtml_1BFEAEDB(content), model_5.MaintenanceActive)]), Cmd_none()];
        case 4:
            return [model, errorCmd((Item_5) => (new Msg(11, [Item_5])), "Laden", exn)];
        case 5:
            return [model, request(Http_getMaintenanceState, undefined, (Item_6) => (new Msg(5, [Item_6])))];
        case 6:
            return [new Model(1, [new TextEditModel(model_7.Key, model_7.Content, model_7.Sending, model_7.IsDirty, model_7.TextAsHtml, state.Value)]), Cmd_none()];
        case 7:
            return [model, errorCmd((Item_8) => (new Msg(11, [Item_8])), "Laden", exn_2)];
        case 8:
            return [new Model(1, [new TextEditModel(model_9.Key, update(model_9.Content, value), model_9.Sending, true, Markdown_ToHtml_1BFEAEDB(value), model_9.MaintenanceActive)]), Cmd_none()];
        case 9:
            return [new Model(1, [new TextEditModel(model_11.Key, model_11.Content, model_11.Sending, model_11.IsDirty, model_11.TextAsHtml, value_1)]), request(Http_postMaintenanceState, value_1, (Item_10) => (new Msg(8, [Item_10])))];
        case 10:
            return [model, Cmd_none()];
        case 11:
            return [model, errorCmd((Item_12) => (new Msg(11, [Item_12])), "Speichern", exn_4)];
        case 12:
            return [new Model(1, [new TextEditModel(model_13.Key, model_13.Content, true, model_13.IsDirty, model_13.TextAsHtml, model_13.MaintenanceActive)]), request((tupledArg) => Http_postText(tupledArg[0], tupledArg[1]), [model_13.Key, model_13.Content.Value], (Item_13) => (new Msg(10, [Item_13])))];
        case 13:
            return [new Model(1, [new TextEditModel(model_15.Key, model_15.Content, false, false, model_15.TextAsHtml, model_15.MaintenanceActive)]), Cmd_none()];
        case 14:
            return [new Model(1, [new TextEditModel(model_17.Key, model_17.Content, false, model_17.IsDirty, model_17.TextAsHtml, model_17.MaintenanceActive)]), errorCmd((Item_17) => (new Msg(11, [Item_17])), "Speichern", e)];
        case 15:
            return [model, Cmd_none()];
        default: {
            return [model, Cmd_none()];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
